import React, { Component } from 'react';
import { connect } from "react-redux";
import { Column, Row } from "@sm/helpers/simple-flexbox";
import { Panel } from "react-bootstrap";
import { NavLink } from 'react-router-dom';

import CustomButton from "@sm/components/custom/Button";
import Form from "@sm/core/Form";
import Multiselect from "@sm/components/custom/customMultiselect";
import PromptModal from '@modules/generateReport/PromptModal';
import Select from "@sm/components/custom/Select";
import Table from '@sm/components/custom/Table';
import Toggler from '@sm/components/custom/Toggler';

import '@assets/css/clients.css';
import loadingIcon from '@assets/images/loading.png';
import PSPIconSingle from '@assets/images/psp_single_wl.png';
import ExpandAllIcon from '@assets/images/expand-all-icon.png';
import CollapseAllIcon from '@assets/images/collapse-all-icon.png';

import * as actions from "@sm/actions";
import { addLogItem } from "@sm/utils/utils";
import { crudActions } from "@sm/services/crudActions";
import { FETCH_PERMISSIONS } from '@sm/actions/types';

const store =  require('@sm/reducers/index');

class PSPs extends Component {
  state = {
    psps: [],
    companies: [],
    availablePspStatuses: [{
      value: "ACTIVE",
      label: "Active"
    }, {
      value: "DEACTIVATED",
      label: "Deactivated"
    }],
    controls: new Form({
      company: "",
      pspStatus: []
    }, [{
      name: "companyIds",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "pspStatus",
      type: "isArray",
      rules: {
        required: true,
        min: 1
      }}]),
    selectedCompany: "",
    searchPattern: "",
    access: [],
    expandAll: true,
    pspStatusLoader: [],
    onOffStatusAccess: false,
    isSuggestionBoxOpen: false,
    roleId: "",
    showProviders: false,
    isDropDownOpen: false,
    openDropdown: null,
    editableStatus: false,
    newStatus: false,
    showPromptModal: false,
    changeValueMessage: "",
    editablePspId: "",
    editableStatusId: "",
    changeActivePropertyLoading: false,
    isLoading: false,
    columns: [{
      value: "name",
      label: "Provider Name"
    },{
      value: "id",
      label: "API"
    }, store.default.getState().authReducer.roleId === "MASTER_TECH" && {
      value: "shortName",
      label: "Provider Short Name"
    }, {
      value: "companyIds",
      label: "White Label"
    }, {
      value: "active",
      label: "Status"
    },{
      value: "id",
      label: "View",
      centerAligned: true,
      className: "btn view-client",
      route: "/view-provider",
      isAction: true
    }]
  };

  subscribeFunction = null;

  componentDidMount() {
    const { controls, availablePspStatuses } = this.state;
    document.addEventListener("mousedown", this.handleClickOutside);
    const storeState = store.default.getState().authReducer;
    if (storeState.access) {
      const roleId = storeState.roleId;
      this.setState({
        access: storeState.access,
        roleId,
        showProviders: roleId === "WL_ADMIN" || roleId === "WL_USER"
      });
    }

    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().authReducer;

      if (state.userUpdate === FETCH_PERMISSIONS) {
        const roleId = storeState.roleId;
        this.setState({
          access: state.access,
          roleId,
          showProviders: roleId === "WL_ADMIN" || roleId === "WL_USER"
        });
      }
    });

    crudActions.get("v1/companies/labels").then(companies => {
      if (companies) {
        this.setState({
          companies: companies,
          controls: Object.assign(controls, {
            company: companies[0].value,
          }),
          ...(companies.length === 1 && { selectedCompany: companies[0].value })
        }, () => {
          if (companies.length === 1) {
            this.onUpdateClick();
          }
        });
      }
    });

    this.setState({
      controls:  Object.assign(controls, {
        pspStatus: [availablePspStatuses.find(elem => elem.value === "ACTIVE").value]
      }),
    });
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  onSuggestionClick(pspName) {
    this.setState({
      searchPattern: pspName,
      isSuggestionBoxOpen: false
    });
  };

  searchSuggests(isSuggestion) {
    const { psps, searchPattern, selectedCompany } = this.state;

    let sortedProviders = psps;
    if (selectedCompany) {
      sortedProviders = psps.filter(psp => psp.companyIds.includes(selectedCompany));
    }

    const searchValue = searchPattern.toLowerCase();
    if (!searchValue) {
      return isSuggestion ? [] : this.prepareTableData(sortedProviders);
    }

    sortedProviders = sortedProviders.filter(psp => {
      return psp.name.toLowerCase().includes(searchValue) || psp.shortName.toLowerCase().includes(searchValue) || psp.id.toString().includes(searchValue);
    });

    return this.prepareTableData(sortedProviders);
  };

  getActiveSelect = (activeStatus, providerId) => {
    const { availablePspStatuses, editableStatus, editableStatusId } = this.state;

    return editableStatus && editableStatusId === providerId ? (
      <div
        onClick={ (event) => event.stopPropagation() }
        onMouseDown={ (event) => event.stopPropagation() }
      >
        <Select
          className="active-status"
          value={ activeStatus ? "ACTIVE" : "DEACTIVATED" }
          clearable={ false }
          options={ availablePspStatuses }
          onChange={ (e) => this.onChangeActiveStatus(activeStatus, e.value) }
        />
      </div>
    ) : (
      <span
        className="active-status-edit"
        style={ { paddingRight: activeStatus ? "50px" : "0px" } }
        onClick={ (event) => event.stopPropagation() }
        onDoubleClick={ (event) => {
          event.stopPropagation();
          this.onDoubleClickStatus(activeStatus, providerId);
        } }
      >
        {activeStatus ? "Active" : "Deactivated"}
      </span>
    );
  };

  onDoubleClickStatus = (activeStatus, pspId) => {
    this.setState({
      editablePspId: pspId,
      editableStatus: true,
      editableStatusId: pspId
    });
  };

  onChangeActiveStatus = (activeStatus, newValue) => {
    if (newValue !== activeStatus) {
      this.setState({
        showPromptModal: true,
        changeValueMessage: `Do you want to change the Status?`,
        newStatus: newValue === "ACTIVE",
      });
    }
  };

  prepareTableData = (sortedProviders) => {
    const { companies, selectedCompany } = this.state;
    return sortedProviders.map(provider => {
      return {
        ...provider,
        companyIds: companies.find(company => company.value === selectedCompany)?.label || '',
        active: this.getActiveSelect(provider.active, provider.id),
        childNodes: this.getChildNodes(provider),
      };
    });
  };

  getChildNodes = (provider) => {
    const currencyAndMethods = provider.currencyAndMethods;
    const currencyAndMethodsPayout = provider.currencyAndMethodsPayout;
    if (!this.state.onOffStatusAccess || (currencyAndMethods.length === 0 && currencyAndMethodsPayout.length === 0)) {
      return [];
    }
    const childData = new Map();
    this.populateByElements(childData, currencyAndMethods, provider.id,"currencyAndMethods");
    this.populateByElements(childData, currencyAndMethodsPayout, provider.id,"currencyAndMethodsPayout");

    return this.createChildRowsByColumns(childData);
  };

  populateByElements = (childData, currencyAndMethods, providerId, filed) => {
    const isPayin  = filed === 'currencyAndMethods';
    const columnStatusName = isPayin ? "enabled" : "enabledPayout";
    currencyAndMethods.forEach(currencyAndMethod => {
      const { currency, method, enabled } = currencyAndMethod;
      const key = currency + " + " + method;

      const enableToggler = <div className="toggle-switch">
        { this.isLoading(providerId, currency, method, isPayin) ?
          <div className="loading-wrapper">
            <img src={ loadingIcon } alt="loading" style={ { height: "25px" } }/>
          </div>
          : <Toggler
            active={ enabled }
            disabled={ false }
            value={ { currencyAndMethod } }
            onClick={ () => this.onTogglerClick(currencyAndMethod, providerId, !enabled, filed) }
          />
        }
      </div>;
      if (childData.has(key)) {
        childData.get(key)[columnStatusName] = enableToggler;
      } else {
        childData.set(key, { [columnStatusName]: enableToggler });
      }
    });
  };

  isLoading = (providerId, currency, method, isPayin) => {
    const { pspStatusLoader } = this.state;
    return pspStatusLoader.some((item) => item.psId === providerId && item.currency === currency && item.method === method && item.isPayin === isPayin);
  };

  createChildRowsByColumns = (childData) => {
    const { columns } = this.state;
    const result = [];
    const currencies = [...childData.keys()];
    currencies.forEach(currency => {
      const row = {};
      columns.forEach(elem => {
        if (elem.value === "currency") {
          row[elem.value] = currency;
        } else if (elem.value === "enabled") {
          row[elem.value] = childData.get(currency).enabled;
        } else if (elem.value === "enabledPayout") {
          row[elem.value] = childData.get(currency).enabledPayout;
        } else {
          row[elem.value] = "";
        }
      });
      result.push(row);
    });
    return result;
  };

  isBoxOpen() {
    if (this.state.isSuggestionBoxOpen) {
      return <div
        className='search-suggests'>
        {
          this.searchSuggests(true).map((psp, index) => {
            return <div className='suggestion' key={ psp.shortName + index }
              onClick={ () => this.onSuggestionClick(psp.name) }>
              { psp.name }
            </div>;
          })
        }
      </div>;
    }

    return <div></div>;
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({
      searchPattern: value,
      isSuggestionBoxOpen: false
    });
  };

  checkPageAccess = (permissionName) => {
    const { access } = this.state;
    const foundPermission = access.find(elem => elem.permission === permissionName);

    if (!foundPermission) {
      return false;
    }

    return foundPermission.state;
  };

  addNewColumn(columns) {
    // eslint-disable-next-line eqeqeq
    if (columns.find((elem) => elem.label === "Edit")) {
      return columns;
    }
    columns.push({
      value: "id",
      label: "Edit",
      centerAligned: true,
      className: "btn edit-client",
      route: "/edit-provider",
      isAction: true
    });
    return columns;
  };

  onCompanyChange = (event) => {
    const { controls } = this.state;
    this.setState({
      controls: Object.assign(controls, {
        company: event.value,
      }),
    });
  };

  onUpdateClick = () => {
    const { controls } = this.state;
    if (controls.company && controls.isFormValid()) {
      this.setState({
        selectedCompany: controls.company,
        showProviders: true,
        editableStatus: false,
        isLoading: true
      }, () => {
        const { columns, selectedCompany } = this.state;

        Promise.all([
          crudActions.get(`v1/psp?companyId=${selectedCompany}&statuses=${controls.pspStatus}`),
          crudActions.get(`v1/companies/provider-toggle/${selectedCompany}`)
        ])
          .then((data) => {
            const psps = data[0];
            const toggleInfo = data[1];

            this.setState({
              showProviders: true,
              isLoading: false,
              psps
            });

            const isStatusColumnPresent = columns.some((elem) => elem.value === "enabled");
            const isPayoutStatusColumnPresent = columns.some((elem) => elem.value === "enabledPayout");
            const isCurrencyColumnPresent = columns.some((elem) => elem.value === "currency");
            if (toggleInfo.providerOnOffToggleVisible && this.checkPageAccess("PSP_ON_OFF")) {
              if (!isPayoutStatusColumnPresent) {
                columns.splice(4, 0, { value: "enabledPayout", label: "Payout Status" });
              }
              if (!isStatusColumnPresent) {
                columns.splice(4, 0, { value: "enabled", label: "Payin Status" });
              }
              if (!isCurrencyColumnPresent) {
                columns.splice(4, 0, { value: "currency", label: "Currency" });
              }
              this.setState({
                onOffStatusAccess: true
              });
            } else {
              if (isStatusColumnPresent) {
                columns.splice(4, 1);
              }
              if (isPayoutStatusColumnPresent) {
                columns.splice(4, 1);
              }
              if (isCurrencyColumnPresent) {
                columns.splice(4, 1);
              }
              this.setState({
                onOffStatusAccess: false
              });
            }
          })
          .catch(
            err => {
              if (err && err.message) {
                this.props.showAlert(true, "error", err.message);
                this.setState({
                  isLoading: false
                });
              }
            }
          );
      });
    }
  };

  onTogglerClick = (option, providerId, value, field) => {
    const { psps, pspStatusLoader, selectedCompany } = this.state;
    const isPayin = field === 'currencyAndMethods';
    if(this.isLoading(providerId, option.currency, option.method, isPayin)) {
      return;
    }

    if (providerId) {
      this.setState({
        pspStatusLoader: pspStatusLoader.concat({ psId : providerId, currency : option.currency, method: option.method, isPayin: isPayin })
      });
      const getChangeValue = (status) => status ? "Enabled" : "Disabled";
      const logs = addLogItem(
        [],
        "PSP_ENABLED_UPDATE",
        getChangeValue(!value),
        getChangeValue(value),
        option.currency + " + " + option.method,
        providerId,
        isPayin ? "Payin" : "Payout"
      );

      const currentPsp = psps.find(psp => psp.id === providerId);

      crudActions.patch(`v1/psp`, {
        enabled: value,
        id: providerId,
        companyId: selectedCompany,
        currency: option.currency,
        method: option.method,
        isPayin: isPayin,
        changes: logs,
        version: currentPsp.version
      }).then((response) => {
        const defaultValue = currentPsp[field].find((current) => current.currency === option.currency && current.method === 'DEFAULT');
        currentPsp[field] = currentPsp[field].map((currencyAndMethod) => {
          return currencyAndMethod.currency === option.currency && (currencyAndMethod.method === option.method || option.method === 'DEFAULT')
            ? { ...currencyAndMethod, enabled: option.method !== 'DEFAULT' ? !currencyAndMethod.enabled : !defaultValue.enabled }
            : currencyAndMethod;
        });
        currentPsp.version = response?.version;
        this.setState({
          psps,
          pspStatusLoader: this.state.pspStatusLoader.filter(status => status.psId !== providerId && status.currency !== option.currency && status.method !== option.method && status.isPayin === isPayin),
        });
      }).catch(
        err => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
            this.setState({
              pspStatusLoader: this.state.pspStatusLoader.filter(status => status.psId !== providerId && status.currency !== option.currency && status.method !== option.method && status.isPayin === isPayin)
            });
          }
        }
      );
    }
  };

  handleClickOutside = (event) => {
    if (this.state.openDropdown && this.state.openDropdown.id && !event.target.closest('.dropdown')) {
      this.closeDropdown();
    }
  };

  closeDropdown = () => {
    this.setState({ openDropdown: null });
  };

  toggleDropdown = (providerId, isPayin) => {
    const { openDropdown } = this.state;

    if (!openDropdown || openDropdown.id !== providerId) {
      this.setState({
        openDropdown: { id: providerId, isPayin },
      });
      return;
    }

    if (openDropdown.isPayin === isPayin) {
      this.closeDropdown();
      return;
    }

    this.setState({
      openDropdown: { id: providerId, isPayin },
    });
  };

  mapStatus = () => {
    const { availablePspStatuses, controls } = this.state;
    return controls.pspStatus.map(elem => {
      return availablePspStatuses.find(lookupElem => elem === lookupElem.value);
    });
  };

  onStatusChange = (event) => {
    const { controls } = this.state;
    this.setState({
      controls: Object.assign(controls, {
        pspStatus: event.map(elem => elem.value),
      }),
    });
    controls.isFormValid();
  };

  handleConfirmPromptModal = () => {
    const { newStatus, selectedCompany, editablePspId, psps } = this.state;
    const editablePsp = psps.find(psp => psp.id === editablePspId);
    const data = {
      id: editablePspId,
      active: newStatus,
      companyId: selectedCompany,
      version: editablePsp.version
    };
    crudActions.patch(
      `v1/psp/active`,
      data
    ).then( (response) => {
      editablePsp.active = newStatus;
      editablePsp.version = response?.version;
      this.setState({
        showPromptModal: false,
        changeValueMessage: "",
        editablePspId: "",
        alertType: "success",
        alertMessage: "Status has been updated!",
        editableStatus: false,
        psps
      });
    }).catch(
      () => {
        this.props.showAlert(true, "error", "Couldn't update status.");
        this.setState({
          showPromptModal: false,
          changeValueMessage: "",
          editablePspId: "",
        });
      }
    );

  };

  handleClosePromptModal = () => {
    this.setState({
      showPromptModal: false,
      changeValueMessage: ""
    });
  };

  onExpandCollapseClick = () => {
    this.setState({
      expandAll: !this.state.expandAll
    });
  };

  render() {
    const {
      availablePspStatuses,
      columns,
      companies,
      expandAll,
      isLoading,
      onOffStatusAccess,
      searchPattern,
      showProviders,
      showPromptModal,
      controls
    } = this.state;

    if (this.checkPageAccess("PSP_EDIT")) {
      this.addNewColumn(columns);
    }

    return (
      <Row flexGrow={ 1 } className="module apidata clients" vertical='start'>
        <Column flexGrow={ 1 }>
          <Row className="header" flexGrow={ 1 } horizontal='space-between' vertical='center'>
            <Column>
              <Row horizontal='center' vertical='center' style={ { paddingLeft: 15 } }>
                <img src={ PSPIconSingle } alt="" style={ { marginRight: 10 } } />
                Providers
              </Row>
            </Column>
            <Column horizontal='end'>
              <Row horizontal='end' vertical='center'>
                {store.default.getState().authReducer.roleId === "MASTER_TECH" && (
                  <Column horizontal='end' style={ { paddingRight: 15 } }>
                    <Row horizontal='end' vertical='center' style={ { color: '#ccc', fontSize: '12px' } }>
                      <NavLink to={ `/add-provider` } className="btn add-merchant-button">
                        ADD PROVIDER
                      </NavLink>
                    </Row>
                  </Column>
                )}
              </Row>
            </Column>
          </Row>

          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                      SEARCH PROVIDERS
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div className="panel-content" style={ {overflow: 'unset'} }>
                    <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                      <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> White Label </label>
                          <Select
                            name="company"
                            value={ controls.company || '' }
                            required={ true }
                            clearable={ false }
                            onChange={ (value) => this.onCompanyChange(value) }
                            options={ companies }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Status </label>
                          <Multiselect
                            isError={ controls.errors.has("pspStatus") }
                            selectedItems={ this.mapStatus() }
                            items={ availablePspStatuses }
                            type={ "pspStatus" }
                            onChange={ this.onStatusChange } />
                        </Column>
                      </Row>
                      <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' className="input-column">
                          <CustomButton
                            title="Update"
                            type="submit"
                            disabled={ isLoading }
                            onClick={ () => this.onUpdateClick() }
                          />
                        </Column>
                      </Row>
                    </Row>
                  </div>
                </Panel.Body>
              </Panel>
              
              { showProviders && (
                <Panel>
                  <Panel.Heading>
                    <Panel.Title>
                      PROVIDERS INFORMATION
                      <img
                        src={ expandAll ? CollapseAllIcon : ExpandAllIcon }
                        alt={ `${ expandAll ? 'collapse' : 'expand' } all rows` }
                        className="expand-collapse-icon"
                        onClick={ () => this.onExpandCollapseClick() }
                      />
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <div className="panel-content" style={ { overflow: 'unset' } }>
                      <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' className='search-bar'>
                        <input
                          className='form-control'
                          type='text'
                          value={ searchPattern }
                          placeholder="Search Provider"
                          onChange={ this.handleSearchChange }
                        />
                        { this.isBoxOpen() }
                      </Row>

                      <div className="table-content accordion-table clients-wrapper">
                        <Table
                          columns={ columns }
                          data={ this.searchSuggests() }
                          isStriped={ true }
                          defaultSortBy={ columns[0].value }
                          sortDirection="ASC"
                          expandAllRows={ expandAll }
                          useArrow={ true }
                          alwaysClick={ onOffStatusAccess }
                        />
                      </div>
                    </div>
                  </Panel.Body>
                </Panel>
              )}

            </Column>
          </Row>
        </Column>

        <PromptModal
          title="Change status"
          message={ this.state.changeValueMessage }
          handleConfirm={ this.handleConfirmPromptModal }
          handleClose={ this.handleClosePromptModal }
          isLoading={ this.state.changeActivePropertyLoading }
          showModal={ showPromptModal }
        />
      </Row>
    );
  }
};

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(PSPs);
